import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ChatService } from "../../services/chat.service";

@Component({
  selector: 'app-vtuber-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class VtuberNotificationComponent implements OnInit, AfterViewInit {
  message: string = '';
  notifications: any[];
  @ViewChild('notificationBox', {static: true}) notificationBox: ElementRef;

  constructor(
    public auth: AuthService,
    private cs: ChatService
  ) {}

  ngOnInit() {
    this.loadNotifications()
  }

  ngAfterViewInit() {
    this.scrollBottom();
  }

  send() {
    this.notifications.push({
        createdAt: Date.now(),
        message: this.message,
        sender: this.auth.user.uid,
        type: 'message',
        photoURL: this.auth.user.photoURL
    })

    let params = {
        uid: this.auth.user.uid,
        notifications: this.notifications.slice(0).map(item => {
            return {
                message: item.message,
                createdAt: item.createdAt,
                sender: item.sender,
                type: item.type
            }
        })
    }

    this.auth.updateUserData(params)
    this.auth.fetchUser()
    if (this.auth.user.chats) {
        const data = {
            message: this.message,
            sender: this.auth.user.uid,
            type: 'message'
        }

        this.auth.user.chats.map(item => {
          this.cs.sendMessage(item, data, true)
        })
    }
    
    this.message = ''
  
    this.scrollBottom(100);
  }

  loadNotifications() {
    this.notifications = this.auth.user.notifications ? this.auth.user.notifications.map(item => Object.assign({ photoURL: this.auth.user.photoURL}, ...item)).slice(0).sort((a, b) => {
        if (a.createdAt > b.createdAt) return 1;
        if (a.createdAt < b.createdAt) return -1;
        return 0;
    }) : []

  }

  private scrollBottom(time: number = 500) {
    // if (this.notificationBox)
    //     setTimeout(() => this.notificationBox.nativeElement.scrollTo(0, this.notificationBox.nativeElement.scrollHeight), time);
    setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 500);
  }
}
